import React, { useEffect, useState } from 'react';
import BeatLoader from 'react-spinners/BeatLoader';
import LiftsToday from './components/LiftsToday';

const TodayPageLifts = () => {
  const [lifts, setLifts] = useState();
  const [exceptions, setExceptions] = useState();
  const [isLoading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    (async () => {
      await fetchData();
    })();
  }, []);

  async function fetchData() {
    const response = await fetch(
      `/${drupalSettings.current_language}/api/slopes_and_lifts`
    );
    if (response.ok) {
      const data = await response.json();
      setLifts(data.lifts);
      setExceptions(data.exceptions);
      setLoading(false);
    } else {
      setError(true);
      setLoading(false);
    }
  }

  return (
    <div className="today-page-lifts today-page-lifts">
      {!isLoading ? (
        !error ? (
          <>
            {exceptions.length > 0 && (
              <div className="info-liftup">
                <h3 className="info-title">
                  {Drupal.t('Exceptions to opening hours')}
                </h3>
                {exceptions.map((exception, i) => (
                  <p key={i} className="info-text">
                    {exception}
                  </p>
                ))}
              </div>
            )}
            <LiftsToday lifts={lifts} />
          </>
        ) : (
          <h3>{Drupal.t('Error fetching data')}</h3>
        )
      ) : (
        <div className="accommodation-search__spinner">
          <BeatLoader color="#ff1706" />
        </div>
      )}
    </div>
  );
};

export default TodayPageLifts;
